import { useState, useEffect } from 'react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollUp = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  if (!visible) return null;

  return (
    <button
      onClick={scrollUp}
      aria-label="Back to top"
      className="fixed bottom-6 right-6 z-50 w-11 h-11 rounded-full bg-[#2D7F3E] text-white shadow-lg hover:bg-[#256632] hover:shadow-xl transition-all duration-200 flex items-center justify-center cursor-pointer animate-scale-in"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}
